import { useEffect } from 'react';
import { useIntl } from 'react-intl';

import Timer from '@/components/app/guide/Timer';
import NarratorImage from '@/components/app/program/NarratorImage';

import { GuideLayoutProps } from '../GuideLayout/types';
import messages from './messages';
import {
	DesktopOnly,
	GuideMetaContainer,
	GuideMetaCopy,
	GuideMetaHeading,
	ProgramDescription,
	ProgramTitle,
} from './styles';

const GuideInfo = ({ program, guide }: GuideLayoutProps) => {
	const { formatMessage } = useIntl();

	const isTimer = program?.meditation_type === 'timer';

	const description =
		guide?.title.toLowerCase() !== program?.title.toLowerCase() ? guide?.title : program?.description;

	const getNarratorDisplayTitle = () => {
		if (program?.meditation_type === 'masterclass') {
			return messages.instructorTitle;
		}

		if (program?.meditation_type === 'music' || program?.meditation_type === 'soundscape') {
			return messages.artistTitle;
		}

		if (program?.narrator?.is_composer) {
			return messages.composerTitle;
		}

		return messages.narratorTitle;
	};

	const guidePersonnel = [
		{
			heading: getNarratorDisplayTitle(),
			copy: program?.narrator?.name,
		},
		{
			heading: messages.authorTitle,
			copy: program?.author?.name,
		},
		{
			heading: messages.hostTitle,
			copy: program?.host?.name,
		},
		{
			heading: messages.guestTitle,
			copy: program?.guest?.name,
		},
	].filter(person => person.copy !== undefined);

	// Focus heading on screen change
	useEffect(() => {
		const heading = document.querySelector('h1');
		if (heading) {
			heading.focus();
		}
	}, []);

	return (
		<>
			<DesktopOnly>
				<NarratorImage theme="large" program={program} />
			</DesktopOnly>
			<ProgramTitle tabIndex={-1}>{program?.title}</ProgramTitle>
			{!isTimer ? (
				<ProgramDescription>{description}</ProgramDescription>
			) : (
				<Timer program={program} guide={guide} />
			)}
			<GuideMetaContainer $justifyContent={guidePersonnel.length > 1 ? 'space-around' : 'center'}>
				{guidePersonnel.map(person => (
					<div key={formatMessage(person.heading)}>
						<GuideMetaHeading>{formatMessage(person.heading)}</GuideMetaHeading>
						<GuideMetaCopy>{person.copy}</GuideMetaCopy>
					</div>
				))}
			</GuideMetaContainer>
		</>
	);
};

export default GuideInfo;
